import { useCallback, useEffect, useMemo } from 'react';
import { FJGeneratingPageAction } from '../../redux/action/FJGeneratingPageAction';
import { FJSettingPageAction } from '../../redux/action/FJSettingPageAction';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import useLocalStore from '../../hooks/useLocalStore';
import FJGeneratingSettingsPanel from './FJGeneratingSettingsPanel';
import FJRequirementsUtil from '@src/util/FJRequirementsUtil';
import { FJ_COMMON_VIEW } from '../../redux/slice/FJCommonSlice';

export default function FJGeneratingSettingsPanelContainer() {
    useLocalStore();
    const dispatch = useAppDispatch();
    const activeView = useAppSelector(state => state.common.activeView);
    const video = useAppSelector(state => state.generatingPage.video);
    const freeNumber = useAppSelector(state => state.common.freeTimes);
    const totalCredits = useAppSelector(state => state.common.totalCredits);
    const originalLanguageKey = useAppSelector(state => state.settingPage.originalLanguageKey);
    const textLanguageKey = useAppSelector(state => state.settingPage.textLanguageKey);
    const genreKey = useAppSelector(state => state.settingPage.genreKey);
    const clipLengthKey = useAppSelector(state => state.settingPage.clipLengthKey);
    const aspectRatioKey = useAppSelector(state => state.settingPage.aspectRatioKey);
    const subtitleStyleId = useAppSelector(state => state.settingPage.subtitleStyleId);
    const captureKeyMoments = useAppSelector(state => state.settingPage.captureKeyMoments);

    useEffect(() => {
        if (activeView === FJ_COMMON_VIEW.SETTING) {
            FJRequirementsUtil.eaLog('long_to_shorts_vedio_setting_page_view');
        }
    }, [activeView]);

    const handleRemoveVideo = useCallback(() => {
        dispatch(FJGeneratingPageAction.removeVideoAction());
    }, [dispatch]);

    const handleGenerate = useCallback(() => {
        dispatch(FJSettingPageAction.generateAction());
    }, [dispatch]);

    const settings = useMemo(
        () => ({
            video,
            freeNumber,
            totalCredits,
            onRemoveVideo: handleRemoveVideo,
            originalLanguageKey,
            onOriginalLanguageKey: (key: string) => dispatch(FJSettingPageAction.setOriginalLanguageKeyAction(key)),
            textLanguageKey,
            onTextLanguageKey: (key: string) => dispatch(FJSettingPageAction.setTextLanguageKeyAction(key)),
            genreKey,
            onGenreKey: (key: string) => dispatch(FJSettingPageAction.setGenreKeyAction(key)),
            clipLengthKey,
            onClipLengthKey: (key: string) => dispatch(FJSettingPageAction.setClipLengthKeyAction(key)),
            aspectRatioKey,
            onAspectRatioKey: (key: string) => dispatch(FJSettingPageAction.setAspectRatioKeyAction(key)),
            subtitleStyleId,
            onSubtitleStyleId: (id: string) => dispatch(FJSettingPageAction.setSubtitleStyleIdAction(id)),
            captureKeyMoments,
            onCaptureKeyMoments: (v: string) => dispatch(FJSettingPageAction.setCaptureKeyMomentsAction(v)),
            onGenerate: handleGenerate,
        }),
        [
            aspectRatioKey,
            captureKeyMoments,
            clipLengthKey,
            dispatch,
            genreKey,
            handleGenerate,
            handleRemoveVideo,
            originalLanguageKey,
            subtitleStyleId,
            video,
            textLanguageKey,
            freeNumber,
            totalCredits,
        ],
    );

    return <FJGeneratingSettingsPanel {...settings} />;
}
